import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/alliance/info-logo.png';
import _imports_1 from '@/assets/alliance/info-logo@2x.png';
import _imports_2 from '@/assets/alliance/info-logo@3x.png';

const _withScopeId = n => (_pushScopeId("data-v-51c2cdca"), n = n(), _popScopeId(), n);

const _hoisted_1 = _imports_1 + ' 1x, ' + _imports_2 + ' 2x';

const _hoisted_2 = {
  class: "block"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  srcset: _hoisted_1,
  alt: "block"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_createTextVNode("What is ");

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_6 = /*#__PURE__*/_createTextVNode("Alliance NFT?");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Alliance NFT is a new NFT Pass launched by alliance partners. This NFT is used for accessing new utilities and communities of Alliance NFT partners. ");

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Similar to Star Alliance in the airline industry, Alliance NFT partners can collaboratively develop a better NFT community and value retention system. ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_block_with_image = _resolveComponent("block-with-image");

  return _openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_block_with_image, {
    imagePosition: "left"
  }, {
    image: _withCtx(() => [_hoisted_3]),
    title: _withCtx(() => [_hoisted_4, _hoisted_5, _hoisted_6]),
    content: _withCtx(() => [_hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10]),
    _: 1
  })]);
}